import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api, tokenStore } from '../api/client.js';
import { useAuth } from '../auth/AuthContext.jsx';
import { Logo } from '../components/ui/Logo.jsx';

export function InviteAccept() {
  const { token } = useParams();
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) {
      setErr('Token lipsă.');
      setLoading(false);
      return;
    }
    api(`/auth/invites/${token}`)
      .then((data) => {
        setInfo(data);
        setLoading(false);
      })
      .catch((ex) => {
        setErr(
          ex.body?.error === 'invite_expired' ? 'Invitația a expirat.' :
          ex.body?.error === 'invite_already_used' ? 'Invitația a fost deja folosită.' :
          'Invitație invalidă.',
        );
        setLoading(false);
      });
  }, [token]);

  async function onSubmit(e) {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      const data = await api('/auth/invites/accept', {
        method: 'POST',
        body: { token, password, name },
      });
      tokenStore.set(data.token);
      await refresh();
      navigate('/', { replace: true });
    } catch (ex) {
      setErr(ex.body?.error || 'Eroare.');
    } finally {
      setBusy(false);
    }
  }

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center text-muted">Se încarcă invitația…</div>;
  }

  if (err && !info) {
    return (
      <div className="mx-auto flex min-h-screen max-w-md items-center justify-center px-4">
        <div className="card text-center">
          <h2 className="text-2xl font-semibold tracking-tight">Problemă cu invitația</h2>
          <p className="mt-2 text-sm text-danger">{err}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-4">
      <div className="mb-8 flex justify-center">
        <Logo size={64} />
      </div>
      <form onSubmit={onSubmit} className="card space-y-4">
        <h2 className="text-2xl font-semibold tracking-tight">Activează contul</h2>
        <p className="text-sm text-muted">
          Ai fost invitat pe <span className="font-semibold text-ink">daruto</span>
          {info.tenant_name && <> de <span className="font-semibold text-ink">{info.tenant_name}</span></>}.
          După activare poți adăuga mașinile tale și vei primi notificări când documentele urmează să expire (RCA, ITP, rovinietă etc.).
        </p>
        <p className="text-xs text-muted">
          Contul este legat de emailul <span className="font-mono text-ink">{info.email}</span>.
          {info.role === 'admin' && <> Vei fi <span className="font-semibold">administrator</span>.</>}
        </p>

        {err && <div className="rounded-lg border border-danger/30 bg-danger/10 px-3 py-2 text-sm text-danger">{err}</div>}

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Numele tău</span>
          <input
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
          />
        </label>

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Parolă (min. 10)</span>
          <input
            type="password"
            required
            minLength={10}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
          />
        </label>

        <button type="submit" disabled={busy} className="btn-primary w-full">
          {busy ? 'Se activează…' : 'Activează contul'}
        </button>
      </form>
    </div>
  );
}
